import { useBlades } from '@/roadmaps/use/use-blades';

const state = {
    itemPromote: {
        visible: false,
        details: {
            promoteParentUpdates: null,
            children: null,
            importeditem: null,
            resolvingItems: null,
        },
    },
    deleteRoadmap: {
        visible: false,
        id: null,
        title: null,
    },
    conflict: {
        visible: false,
    },
    deleteSingleSwimlane: {
        visible: false,
        swimlaneToDelete: null,
    },
    deleteItem: {
        visible: false,
        itemToDelete: null,
    },
    unlinkBacklogItem: {
        visible: false,
        source: null,
        parent: null,
        itemsToUpdateIfUnlinking: null,
        itemsToUpdateIfAddingGroup: null,
    },
    shareRoadmap: {
        visible: false,
    },
    createSwimlane: {
        visible: false,
        indexToAdd: null,
    },
    updateSwimlane: {
        visible: false,
        swimlane: null,
    },
    updateRoadmap: {
        visible: false,
    },
    setQuarterOneStartingMonth: {
        visible: false,
    },
    deleteColumn: {
        visible: false,
        columnToDelete: null,
    },
};

const mutations = {
    openItemPromoteModal (state, details) {
        state.itemPromote.visible = true;
        state.itemPromote.details = details;
    },
    closeItemPromoteModal (state) {
        state.itemPromote.visible = false;
        state.itemPromote.details = {
            promoteParentUpdates: null,
            children: null,
            importeditem: null,
            resolvingItems: null,
        };
    },
    openDeleteRoadmapModal (state, { id, title }) {
        state.deleteRoadmap.visible = true;
        state.deleteRoadmap.id = id;
        state.deleteRoadmap.title = title;
    },
    closeDeleteRoadmapModal (state) {
        state.deleteRoadmap.visible = false;
        state.deleteRoadmap.id = null;
        state.deleteRoadmap.title = null;
    },
    openConflictModal (state) {
        state.conflict.visible = true;
    },
    closeConflictModal (state) {
        state.conflict.visible = false;
    },
    openDeleteSingleSwimlaneModal (state, swimlaneToDelete) {
        state.deleteSingleSwimlane.visible = true;
        state.deleteSingleSwimlane.swimlaneToDelete = swimlaneToDelete;
    },
    closeDeleteSingleSwimlaneModal (state) {
        state.deleteSingleSwimlane.visible = false;
        state.deleteSingleSwimlane.swimlaneToDelete = null;
    },
    openDeleteItemModal (state, itemToDelete) {
        state.deleteItem.visible = true;
        state.deleteItem.itemToDelete = itemToDelete;
    },
    closeDeleteItemModal (state) {
        state.deleteItem.visible = false;
        state.deleteItem.itemToDelete = null;
    },
    openUnlinkBacklogItemModal (state, { source, parent, itemsToUpdateIfUnlinking, itemsToUpdateIfAddingGroup }) {
        state.unlinkBacklogItem.visible = true;
        state.unlinkBacklogItem.source = source;
        state.unlinkBacklogItem.parent = parent;
        state.unlinkBacklogItem.itemsToUpdateIfUnlinking = itemsToUpdateIfUnlinking;
        state.unlinkBacklogItem.itemsToUpdateIfAddingGroup = itemsToUpdateIfAddingGroup;
    },
    closeUnlinkBacklogItemModal (state) {
        state.unlinkBacklogItem.visible = false;
        state.unlinkBacklogItem.source = null;
        state.unlinkBacklogItem.parent = null;
        state.unlinkBacklogItem.itemsToUpdateIfUnlinking = null;
        state.unlinkBacklogItem.itemsToUpdateIfAddingGroup = null;
    },
    openShareRoadmapModal (state) {
        state.shareRoadmap.visible = true;
    },
    closeShareRoadmapModal (state) {
        state.shareRoadmap.visible = false;
    },
    openCreateSwimlaneModal (state, indexToAdd) {
        state.createSwimlane.visible = true;
        state.createSwimlane.indexToAdd = indexToAdd;
    },
    closeCreateSwimlaneModal (state) {
        state.createSwimlane.visible = false;
        state.createSwimlane.indexToAdd = null;
    },
    openUpdateSwimlaneModal (state, swimlane) {
        state.updateSwimlane.visible = true;
        state.updateSwimlane.swimlane = swimlane;
    },
    closeUpdateSwimlaneModal (state) {
        state.updateSwimlane.visible = false;
        state.updateSwimlane.swimlane = null;
    },
    openUpdateRoadmapModal (state) {
        state.updateRoadmap.visible = true;
    },
    closeUpdateRoadmapModal (state) {
        state.updateRoadmap.visible = false;
    },
    openSetQuarterOneStartingMonthModal (state) {
        state.setQuarterOneStartingMonth.visible = true;
    },
    closeSetQuarterOneStartingMonthModal (state) {
        state.setQuarterOneStartingMonth.visible = false;
    },
    openDeleteColumnModal (state, columnToDelete) {
        state.deleteColumn.visible = true;
        state.deleteColumn.columnToDelete = columnToDelete;
    },
    closeDeleteColumnModal (state) {
        state.deleteColumn.visible = false;
        state.deleteColumn.columnToDelete = null;
    },
};

const actions = {
    closeAllModals ({ commit, getters }) {
        if (!getters.isAnyModalOpen) return;
        commit('closeItemPromoteModal');
        commit('closeDeleteRoadmapModal');
        commit('closeConflictModal');
        commit('closeDeleteSingleSwimlaneModal');
        commit('closeDeleteItemModal');
        commit('closeUnlinkBacklogItemModal');
        commit('closeShareRoadmapModal');
        commit('closeCreateSwimlaneModal');
        commit('closeUpdateSwimlaneModal');
        commit('closeUpdateRoadmapModal');
        commit('closeSetQuarterOneStartingMonthModal');
        commit('closeDeleteColumnModal');
    },
    openItemPromoteModal ({ commit }, details) {
        commit('openItemPromoteModal', details);
    },
    openDeleteRoadmapModal ({ commit }, { id, title }) {
        commit('openDeleteRoadmapModal', { id, title });
    },
    openConflictModal ({ commit, dispatch }) {
        dispatch('closeAllModals');
        const { closeAllBlades } = useBlades();
        closeAllBlades();
        commit('openConflictModal');
    },
    openDeleteSingleSwimlaneModal ({ commit }, swimlaneToDelete) {
        commit('openDeleteSingleSwimlaneModal', swimlaneToDelete);
    },
    openDeleteItemModal ({ commit }, itemToDelete) {
        commit('openDeleteItemModal', itemToDelete);
    },
    openUnlinkBacklogItemModal ({ commit }, { source, parent, itemsToUpdateIfUnlinking, itemsToUpdateIfAddingGroup }) {
        commit('openUnlinkBacklogItemModal', { source, parent, itemsToUpdateIfUnlinking, itemsToUpdateIfAddingGroup });
    },
    openShareRoadmapModal ({ commit }) {
        commit('openShareRoadmapModal');
    },
    openCreateSwimlaneModal ({ commit }, indexToAdd) {
        commit('openCreateSwimlaneModal', indexToAdd);
    },
    openUpdateSwimlaneModal ({ commit }, swimlane) {
        commit('openUpdateSwimlaneModal', swimlane);
    },
    openUpdateRoadmapModal ({ commit }) {
        commit('openUpdateRoadmapModal');
    },
    openSetQuarterOneStartingMonthModal ({ commit }) {
        commit('openSetQuarterOneStartingMonthModal');
    },
    openDeleteColumnModal ({ commit }, columnToDelete) {
        commit('openDeleteColumnModal', columnToDelete);
    },
};

const getters = {
    isItemPromoteModalVisible: (state) => state.itemPromote.visible,
    isConflictModalVisible: (state) => state.conflict.visible,
    isDeleteSingleSwimlaneModalVisible: (state) => state.deleteSingleSwimlane.visible,
    isDeleteRoadmapModalVisible: (state) => state.deleteRoadmap.visible,
    isUnlinkBacklogItemModalVisible: (state) => state.unlinkBacklogItem.visible,
    isDeleteColumnModalVisible: (state) => state.deleteColumn.visible,
    isAnyModalOpen: (state) => Object.values(state).some((modal) => modal.visible),
    promoteModalDetails: (state) => state.itemPromote.details,
    deleteRoadmapDetails: (state) => ({
        id: state.deleteRoadmap.id,
        title: state.deleteRoadmap.title,
    }),
    deleteSingleSwimlaneModalSwimlaneToDelete: (state) => state.deleteSingleSwimlane.swimlaneToDelete,
    isDeleteItemModalVisible: (state) => state.deleteItem.visible,
    deleteItemModalItemToDelete: (state) => state.deleteItem.itemToDelete,
    unlinkBacklogItemModalDetails: (state) => ({
        source: state.unlinkBacklogItem.source,
        parent: state.unlinkBacklogItem.parent,
        itemsToUpdateIfUnlinking: state.unlinkBacklogItem.itemsToUpdateIfUnlinking,
        itemsToUpdateIfAddingGroup: state.unlinkBacklogItem.itemsToUpdateIfAddingGroup,
    }),
    isShareRoadmapModalVisible: (state) => state.shareRoadmap.visible,
    isCreateSwimlaneModalVisible: (state) => state.createSwimlane.visible,
    createSwimlaneModalIndexToAdd: (state) => state.createSwimlane.indexToAdd,
    isUpdateSwimlaneModalVisible: (state) => state.updateSwimlane.visible,
    updateSwimlaneModalSwimlane: (state) => state.updateSwimlane.swimlane,
    isUpdateRoadmapModalVisible: (state) => state.updateRoadmap.visible,
    isSetQuarterOneStartingMonthModalVisible: (state) => state.setQuarterOneStartingMonth.visible,
    deleteColumnModalColumnToDelete: (state) => state.deleteColumn.columnToDelete,
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
